import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, UtensilsCrossed, ShoppingBag, Building2, Home as HomeIcon, BarChart3 } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { Eyebrow } from "./Bits";
import { useDirectoryAvailability } from "../lib/useDirectoryAvailability";

const DIR_KEYS = ["restaurants", "shopping", "directory"];

const ENTRIES = [
  ["restaurants", "/restaurants", UtensilsCrossed],
  ["shopping", "/shopping", ShoppingBag],
  ["directory", "/directory", Building2],
  ["property", "/property", HomeIcon],
  ["broker", "/partners/broker", BarChart3],
];

export const HomeDiscover = () => {
  const { t } = useLang();
  const counts = useDirectoryAvailability() || {};
  const entries = ENTRIES.filter(([key]) => !DIR_KEYS.includes(key) || counts[key] > 0);
  return (
    <section className="max-w-[1400px] mx-auto px-5 lg:px-8 mt-24" data-testid="home-discover-section">
      <Eyebrow>{t("home.discover.eyebrow")}</Eyebrow>
      <h2 className="font-display text-3xl sm:text-4xl text-white mt-2">{t("home.discover.h")}</h2>
      <p className="text-white/55 mt-2 max-w-2xl">{t("home.discover.p")}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mt-8" data-testid="home-discover-grid">
        {entries.map(([key, to, Icon], i) => (
          <Link key={key} to={to} data-testid={`home-discover-${key}`} style={{ animationDelay: `${i * 70}ms` }}
            className="group flex flex-col rounded-2xl bg-surface/60 border border-white/[0.06] p-6 hover:border-gold/30 hover:-translate-y-1 transition-[transform,border-color] duration-300">
            <Icon size={20} className="text-gold" />
            <div className="font-display text-lg text-white mt-3">{t(`home.discover.items.${key}.h`)}</div>
            <div className="text-white/50 text-sm mt-1">{t(`home.discover.items.${key}.p`)}</div>
            <div className="inline-flex items-center gap-1 text-xs text-gold/80 mt-auto pt-4 group-hover:gap-2 transition-[gap] duration-200">
              {t("home.discover.open")} <ArrowRight size={12} className="rtl:rotate-180" />
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};
